/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {EnvironmentalBenefitFieldEditor} from "../ServiceDrivenEditors";

export const ProgramEnvironmentalBenefitFieldEditor = (props) => {
	const {Value, RootData, filter = null} = props;
	
	const filterResults = (values, selectedModel) => {
		
		values = filter?.(values, selectedModel) ?? values;
		
		//strip already selected EnvironmentalBenefits
		let selectedIds = [];
		if (RootData.ProgramEnvironmentalBenefits) {
			selectedIds = RootData.ProgramEnvironmentalBenefits
				.map(x => x.environmentalBenefitId)
				.filter(x => !isNaN(x))
				.filter(x => x !== Value);
		}
		
		return values.filter(x => !selectedIds.includes(x.environmentalBenefitId));
	}
	
	return <EnvironmentalBenefitFieldEditor
		{...props}
		filter={filterResults}
	/>;
}
